<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import Button from 'dashboard/components-next/button/Button.vue';
import { useUISettings } from 'dashboard/composables/useUISettings';
import { useMapGetter } from 'dashboard/composables/store';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

const route = useRoute();

const { uiSettings, updateUISettings } = useUISettings();

const currentAccountId = useMapGetter('getCurrentAccountId');
const isFeatureEnabledonAccount = useMapGetter(
  'accounts/isFeatureEnabledonAccount'
);

// Show only on Audios tab (telephony_ivr without tab=flows)
const isAudiosTab = computed(() => {
  return (
    (route.name === 'telephony_ivr' || route.name === 'whatsapp_calling_ivr') &&
    route.query.tab !== 'flows'
  );
});

const showElevenLabsLauncher = computed(() => {
  const isTelephonyEnabled =
    isFeatureEnabledonAccount.value(
      currentAccountId.value,
      FEATURE_FLAGS.ASTERISK_TELEPHONY
    ) ||
    isFeatureEnabledonAccount.value(
      currentAccountId.value,
      FEATURE_FLAGS.WHATSAPP_SIP_TELEPHONY
    );
  return (
    isTelephonyEnabled &&
    !uiSettings.value.is_elevenlabs_panel_open &&
    isAudiosTab.value
  );
});

const toggleSidebar = () => {
  updateUISettings({
    is_elevenlabs_panel_open: !uiSettings.value.is_elevenlabs_panel_open,
  });
};
</script>

<template>
  <div
    v-if="showElevenLabsLauncher"
    class="fixed bottom-4 ltr:right-4 rtl:left-4 z-50"
  >
    <div class="rounded-full bg-n-alpha-2 p-1">
      <Button
        v-tooltip.left="'ElevenLabs TTS'"
        icon="i-lucide-audio-lines"
        class="!rounded-full !bg-n-solid-3 dark:!bg-n-alpha-2 !text-n-slate-12 text-xl"
        lg
        @click="toggleSidebar"
      />
    </div>
  </div>
  <template v-else />
</template>
